export default __webpack_public_path__ + "static/media/delivery.d6f0ec3b.svg";